export interface GlossaryEntry {
  term: string;
  description: string;
}

/**
 * Glossário central de termos da plataforma — usado pelo componente InfoTooltip.
 * Textos em PT-BR, sem jargão técnico (persona: leigo em tecnologia).
 */
export const GLOSSARY = {
  xp: {
    term: 'XP',
    description:
      'Pontos de Experiência. Você ganha completando aulas, missões e mantendo sequência diária.',
  },
  level: {
    term: 'Nível',
    description:
      'Seu nível atual. Sobe a cada faixa de XP. Quanto mais alto, mais badges você desbloqueia.',
  },
  streak: {
    term: 'Streak',
    description:
      'Dias seguidos que você acessou a plataforma. Cuidado pra não quebrar a sequência!',
  },
  mission: {
    term: 'Missão',
    description: 'Desafios extras com XP bônus. Aparecem aqui quando estiverem ativas.',
  },
  achievement: {
    term: 'Conquista',
    description:
      'Badges que você desbloqueou ao completar requisitos. Veja todas em Meu Perfil.',
  },
  trail: {
    term: 'Trilha',
    description:
      'Conjunto curto de aulas sobre um tema. Você pode fazer no seu ritmo, parar e voltar.',
  },
  iniciante: {
    term: 'Iniciante',
    description:
      'Nível recomendado de conhecimento prévio. "Iniciante" significa: você nunca mexeu com isso.',
  },
  duration_xp: {
    term: 'XP da trilha',
    description:
      'Pontuação total que você ganha completando todas as aulas dessa trilha.',
  },
  agent_sql: {
    term: 'Text-to-SQL',
    description:
      'Esse agente entende perguntas em português normal e consulta os dados da empresa pra te responder.',
  },
  ranking_geral: {
    term: 'Ranking Geral',
    description:
      'Ranking individual de todos os usuários, ordenado por XP total na temporada.',
  },
  ranking_setor: {
    term: 'Ranking por Setor',
    description:
      'Como seu departamento está indo contra os outros. Soma o XP de todos do mesmo setor.',
  },
  tendencia: {
    term: 'Tendência',
    description:
      'Indica se o setor está subindo, descendo ou estável comparado à temporada anterior.',
  },
  badge_rarity: {
    term: 'Raridade do badge',
    description:
      'Comum < Raro < Épico < Lendário. Quanto mais raro, mais difícil de conseguir.',
  },
  perfil_publico: {
    term: 'Perfil Público',
    description:
      'Se ligado, outros usuários veem seu perfil completo. Se desligado, só veem nome e nível.',
  },
  em_breve: {
    term: 'Em breve',
    description:
      'Essa funcionalidade ainda não está disponível. Fica de olho, vai aparecer aqui em breve!',
  },
  nps: {
    term: 'NPS',
    description:
      'Net Promoter Score. Mede recomendação: detratores (0-6), neutros (7-8) e promotores (9-10). NPS = % promotores − % detratores, vai de -100 a +100.',
  },
  csat: {
    term: 'CSAT',
    description:
      'Customer Satisfaction. Quão satisfeito o aluno ficou com o curso, na escala 0-10. Mostramos a média geral e por curso.',
  },
} as const satisfies Record<string, GlossaryEntry>;

export type GlossaryKey = keyof typeof GLOSSARY;
